module.exports = "/_next/static/images/headerBg-6afa210df43543fc1d018264bbc6ec29.webp";